<template>
  <div v-once class="PAUSED-LEADS-LIST-PLACEHOLDER">
    <span class="c-gray70 p-b-4 MESSAGE">
      You have no paused lead dates.
      Pause your leads to save points when you’re busy or need a break.
    </span>
    <img alt="pausedLeads" src="./assets/EmptySuccessVacation.svg" />
  </div>
</template>

<script>
export default {
  name: 'paused-leads-list-placeholder',
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .PAUSED-LEADS-LIST-PLACEHOLDER {
    @include padding(2 4 2, $md: 4 5 4);
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: center;
    text-align: left;
    background-color: white;
  }
  .MESSAGE {
    max-width: 500px;
  }
</style>
